import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col items-center gap-3 py-16 text-center">
      <p className="text-lg font-medium">{t('notFound.title')}</p>
      <Link to="/" className="text-link">
        {t('notFound.goHome')}
      </Link>
    </div>
  );
}
